module.exports = __webpack_public_path__ + "static/media/group_25@2x.aff22833.jpg";